// 갤러리 카드 — Firestore config/galleryBriefs (공개 읽기). 필드와 쓰는 법은
// functions/gallery-briefs.js 맨 위. 문서가 없거나 못 읽으면 카드 없음 —
// 앱이 스스로 만드는 카드(시즌·크레딧·초대)만 뜬다 (components/GalleryBriefs.jsx).
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.js';
import { getPlatform } from './platform-service.js';

const TTL = 5 * 60 * 1000;
const CLOSED_KEY = 'archelier_briefs_closed';
let cache = { at: 0, val: [] };
let inflight = null;

export async function loadGalleryBriefs() {
  if (Date.now() - cache.at < TTL) return cache.val;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const snap = await getDoc(doc(db, 'config', 'galleryBriefs'));
      const raw = snap.exists() ? snap.data().briefs : null;
      const val = (Array.isArray(raw) ? raw : []).filter((b) => (
        b && typeof b.id === 'string' && b.text?.en?.title
      ));
      cache = { at: Date.now(), val };
    } catch (e) {
      console.warn('gallery briefs load failed:', e?.message);
      cache = { at: Date.now(), val: [] };
    } finally {
      inflight = null;
    }
    return cache.val;
  })();
  return inflight;
}

// 읽는 사람의 언어, 없으면 영어.
export function briefText(b, lang) {
  return b.text?.[lang]?.title ? b.text[lang] : b.text?.en;
}

// { 카드 id: 닫은 시각 } — 이 기기에만.
function closedAt() {
  try {
    const v = JSON.parse(localStorage.getItem(CLOSED_KEY) || '{}');
    return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  } catch { return {}; }
}

export function closeBrief(id) {
  try {
    const map = closedAt();
    map[id] = Date.now();
    // 최근 50개만 — 오래된 카드는 이미 문서에서 빠졌다.
    const kept = Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 50));
    localStorage.setItem(CLOSED_KEY, JSON.stringify(kept));
  } catch { /* 사생활 보호 모드: 다음 방문에 다시 뜬다 */ }
}

// 닫았고 아직 돌아올 때가 안 됐는가. reshowDays 가 없으면 영영.
export function isBriefClosed(b, now = Date.now()) {
  const at = closedAt()[b.id];
  if (!at) return false;
  return !(b.reshowDays > 0) || now < at + b.reshowDays * 864e5;
}

// 문서 카드 중 지금 이 사람에게 뜰 것.
export function liveRemoteBriefs(list, { signedIn, now = Date.now() }) {
  const platform = getPlatform();
  return (list || []).filter((b) => (
    b.active !== false
    && (!b.from || Date.parse(b.from) <= now)
    && (!b.until || Date.parse(b.until) > now)
    && (!Array.isArray(b.platforms) || !b.platforms.length || b.platforms.includes(platform))
    && !(b.audience === 'signedIn' && !signedIn)
    && !(b.audience === 'guest' && signedIn)
    && !isBriefClosed(b, now)
  ));
}
